import { type HTMLAttributes } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

import { cn } from '../lib/utils';

const inputGroupVariants = tv({
  base: 'mb-4'
});

type InputGroupVariants = VariantProps<typeof inputGroupVariants>;

type InputGroupProps = HTMLAttributes<HTMLDivElement>;

function InputGroup({ className, children, ...props }: InputGroupProps) {
  return (
    <div className={cn(inputGroupVariants(), className)} {...props}>
      {children}
    </div>
  );
}

export { InputGroup, inputGroupVariants };
export type { InputGroupProps, InputGroupVariants };
